(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactRouterDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactRouterDOM"], factory);
	else if(typeof exports === 'object')
		exports["PluginCRM"] = factory(require("React"), require("ReactRouterDOM"));
	else
		root["PluginCRM"] = factory(root["React"], root["ReactRouterDOM"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__1024__, __WEBPACK_EXTERNAL_MODULE__5522__) {
return 